/** @returns The amount above the limit, or zero when the count is within the limit. */
export function getOverLimitCount(count, limit) {
    return Math.max(0, count - limit);
}
//# sourceMappingURL=getOverLimitCount.js.map